import React from 'react';

const Products = () => (
  <section className="py-12 bg-linen-100">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center">
        <h2 className="font-display text-3xl font-semibold text-charcoal-900 sm:text-4xl">
          Our Products
        </h2>
        <p className="mt-4 text-xl text-walnut-600">
          Transforming raw trees into beautiful, functional and timeless heirloom pieces for your home.
        </p>
      </div>
      <div className="mt-10 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        <div className="bg-linen-50 rounded-lg shadow-lg shadow-walnut-900/5 border border-linen-200 p-6">
          <h3 className="font-display text-xl font-semibold text-charcoal-900">Kitchen Utensils</h3>
          <p className="mt-4 text-walnut-600">
            Handmade spoons, spatulas and more
          </p>
        </div>
        <div className="bg-linen-50 rounded-lg shadow-lg shadow-walnut-900/5 border border-linen-200 p-6">
          <h3 className="font-display text-xl font-semibold text-charcoal-900">Food Safe Bowls</h3>
          <p className="mt-4 text-walnut-600">
            Food safe and beautifully crafted bowls
          </p>
        </div>
        <div className="bg-linen-50 rounded-lg shadow-lg shadow-walnut-900/5 border border-linen-200 p-6">
          <h3 className="font-display text-xl font-semibold text-charcoal-900">Rustic Bowls</h3>
          <p className="mt-4 text-walnut-600">
            Bowls with a rustic charm, perfect for any home
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default Products;